import React from 'react';

/**
 * Converts URLs in text to clickable links
 * Supports http, https, and www URLs
 */
export const linkifyText = (text) => {
  if (!text) return null;
  
  // Regex to match URLs
  const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s]|www\.[^\s<]+[^<.,:;"')\]\s])/gi;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      const href = part.startsWith('www.') ? `https://${part}` : part;
      return (
        <a
          key={`link-${index}-${part.slice(0, 20)}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-500 hover:text-amber-400 underline underline-offset-2 transition-colors"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

/**
 * Component that renders text with clickable links
 */
const LinkifiedText = ({ text, className = '' }) => {
  return <span className={className}>{linkifyText(text)}</span>;
};

export default LinkifiedText;
